import { gql } from "@outschool/ui-apollo";

export default gql`
  fragment TimetableFragment on Timetable {
    mon {
      ...TimetableTimesFragment
    }
    tue {
      ...TimetableTimesFragment
    }
    wed {
      ...TimetableTimesFragment
    }
    thu {
      ...TimetableTimesFragment
    }
    fri {
      ...TimetableTimesFragment
    }
    sat {
      ...TimetableTimesFragment
    }
    sun {
      ...TimetableTimesFragment
    }
  }

  fragment TimetableTimesFragment on TimetableTimes {
    f8_12
    f12_4
    f4_8
  }
`;
